const MaterialsList = () =>
  import(/* webpackChunkName: "MaterialsList" */ "@/components/ssp/materials/MaterialsList.vue");

export default [
  {
    path: "",
    name: "materials",
    component: MaterialsList,
  },
];
